import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Spin } from 'antd';
import React, { useEffect, useState } from 'react';
export var DynamicIcon = function DynamicIcon(properties) {
  var value = properties.value,
    mapping = properties.mapping;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    elements = _useState4[0],
    setElements = _useState4[1];
  useEffect(function () {
    var target = mapping && value ? mapping[value] : undefined;
    if (target) {
      if (target instanceof Array) {
        setElements(_toConsumableArray(target));
      } else {
        setElements([target]);
      }
    }
    return function () {
      return setElements([]);
    };
  }, [mapping, value]);
  useEffect(function () {
    var changer = setInterval(function () {
      setIndex(function (_index_) {
        return (_index_ + 1) % elements.length;
      });
    }, 1000);
    return function () {
      setIndex(0);
      clearInterval(changer);
    };
  }, [elements]);
  return elements[index] || /*#__PURE__*/React.createElement(Spin, {
    size: "small"
  });
};